import { render, staticRenderFns } from "./StorehouseDetailAddNew.vue?vue&type=template&id=1f8136aa&scoped=true&"
import script from "./StorehouseDetailAddNew.vue?vue&type=script&lang=js&"
export * from "./StorehouseDetailAddNew.vue?vue&type=script&lang=js&"
import style0 from "./StorehouseDetailAddNew.vue?vue&type=style&index=0&id=1f8136aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8136aa",
  null
  
)

export default component.exports